import axios from 'axios';
import qs from 'qs';
let baseReadURL="http://bz.sdscxh.cn/jeecg-boot/"//本地环境
let baseURL = "http://bz.sdscxh.cn/jeecg-boot/aquatic-web";//生产环境 请求地址前缀
let imageURL = 'http://bz.sdscxh.cn/jeecg-boot/sys/common/static/';//图片地址
// let baseReadURL="http://localhost:8087/jeecg-boot/"//本地环境
// let baseURL = "http://localhost:8087/jeecg-boot/aquatic-web";//生产环境 请求地址前缀
// let imageURL = 'http://localhost:8087/jeecg-boot/sys/common/static/';//图片地址
axios.defaults.baseURL = baseURL;
// 配置超时时间 五分钟
axios.defaults.timeout = 300000;
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

var get = function(url, params, loading) {
    return new Promise((resolve, reject) => {
        // {
        //   params: params
        // }
        axios
            .get(url, params)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
    });
};

 var post = function(url, data) {
    return new Promise((resolve, reject) => {
        data = qs.stringify(data);
        axios
            .post(url, data)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export function updatePassword(parameter) {
    return axios({
      url: '/updatePassword',
      method: 'put',
      data: parameter
    })
  }
export function login(parameter) {
    return axios({
      url: '/login',
      method: 'post',
      data: parameter
    })
  }
  export function loginzc(parameter) {
    return axios({
      url: '/loginzc',
      method: 'post',
      data: parameter
    })
  }
  export function register(parameter) {
    return axios({
      url: '/register',
      method: 'post',
      data: parameter
    })
  }
  export function addlog(parameter) {
    return axios({
      url: '/fwjl',
      method: 'post',
      data: parameter
    })
  }
export default { get,post, baseURL,baseReadURL,login,imageURL,updatePassword,register,addlog,loginzc};



// WEBPACK FOOTER //
// ./src/js/axios.js